import { apiService } from './apiService';

export function getItemExtraService(data) {
    return apiService({
        method: 'POST',
        url: '/item-extra/data',
        data,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function getByIdItemExtraService(id) {
    return apiService({
        method: 'GET',
        url: '/item-extra/' + id,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function addItemExtraService(data) {
    return apiService({
        method: 'POST',
        url: '/item-extra',
        data,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function updateItemExtraService(id, data) {
    return apiService({
        method: 'PUT',
        url: '/item-extra/' + id,
        data,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function deleteItemExtraService(id) {
    return apiService({
        method: 'DELETE',
        url: '/item-extra/' + id,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}
